// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","ServiceInfo":"ServiceInfo","header":"header","itemGroup":"itemGroup","item":"item","ServiceLeft":"ServiceLeft","calendar":"calendar","top":"top","year":"year","bottom":"bottom","date":"date","month":"month","day":"day","ServiceRight":"ServiceRight","time":"time","type":"type","location":"location","description":"description","address":"address"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/ServiceInfo/css/ServiceInfo.styl
// module id = 1670
// module chunks = 0